import ScienceSharp from '@mui/icons-material/ScienceSharp'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import AssignmentIcon from '@mui/icons-material/Assignment'
import DashboardIcon from '@mui/icons-material/Dashboard'
import InsightsIcon from '@mui/icons-material/Insights'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import SettingsIcon from '@mui/icons-material/Settings'
import ViewListIcon from '@mui/icons-material/ViewList'
import { Box, Drawer, Typography } from '@mui/material'
import React from 'react'

import { useKeycloak } from '../../hooks/keycloakContextProvider'
import hasPermissions, { permissions } from '../../utils/validation/hasPermissions'
import { NavItem } from './navItem'

const createButtonTitle = 'Create'
const dailyParamsTitle = 'Monitoring'
const items = [
    {
        href: '/',
        icon: <SettingsIcon fontSize="small" />,
        title: 'Manage',
    },
    {
        href: '/createExperiment',
        icon: <AddCircleOutlineIcon fontSize="small" />,
        title: createButtonTitle,
    },
    {
        href: '/testPlans',
        icon: <AssignmentIcon fontSize="small" />,
        title: 'Test Plans',
    },
    {
        href: '/dailyParams',
        icon: <ViewListIcon fontSize="small" />,
        title: dailyParamsTitle,
    },
    {
        href: '/roi',
        icon: <InsightsIcon fontSize="small" />,
        title: 'ROI Dashboard',
    },
]

interface SidebarProps {
    open: boolean
    onClose: () => void
    handleSideBarToggle: () => void
}

export const DashboardSidebar = ({ open, onClose, handleSideBarToggle }: SidebarProps) => {
    const { roles } = useKeycloak()

    const content = (
        <Box
            sx={{
                display: 'flex',
                width: '100%',
                flexDirection: 'column',
            }}
        >
            {items.map((item) => {
                if (item.title === dailyParamsTitle && !hasPermissions(roles, permissions.updateMonitoring)) {
                    return null
                }
                if (item.title === createButtonTitle && !hasPermissions(roles, permissions.createExperiment)) {
                    return null
                }
                return (
                    <NavItem
                        data-test={'sidebar-item'}
                        key={item.title}
                        icon={item.icon}
                        href={item.href}
                        title={item.title}
                    />
                )
            })}
            {process.env.NEXT_PUBLIC_EMS_URL === 'st' ? (
                <NavItem
                    data-test={'sidebar-item-dashboard'}
                    key={'Dashboard'}
                    icon={<DashboardIcon />}
                    href={'/mockDashboard'}
                    title={'Dashboard'}
                />
            ) : null}
        </Box>
    )
    return (
        <Drawer
            data-test="sidebar-drawer"
            anchor="left"
            open={open}
            onClose={onClose}
            PaperProps={{
                // These props control styles for side bar as a whole
                sx: {
                    backgroundColor: 'rgba(33, 36, 43, 1)',
                    color: '#FFFFFF',
                    border: 0,
                    width: '258px',
                },
            }}
            sx={{ zIndex: (theme) => theme.zIndex.appBar + 100 }}
            variant="persistent"
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    minHeight: 72,
                    backgroundColor: 'rgba(36, 58, 90, 1)',
                    justifyContent: 'space-between',
                }}
            >
                <Typography
                    data-test="expermentation-logo"
                    sx={{ display: 'flex', alignItems: 'center', marginLeft: '20px', fontWeight: 'bold' }}
                >
                    <ScienceSharp fontSize="small" sx={{ color: 'rgba(109, 210, 137, 1)', marginRight: '8px' }} />
                    Experimentation
                </Typography>
                <Box
                    data-test="close-sidebar-button"
                    onClick={handleSideBarToggle}
                    sx={{
                        height: '100%',
                        width: '28px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: 'rgba(0, 0, 0, 0.1)',
                        cursor: 'pointer',
                    }}
                >
                    <KeyboardArrowLeftIcon fontSize="small" />
                </Box>
            </Box>
            {content}
        </Drawer>
    )
}
